var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main__container"},_vm._l((_vm.collections),function(col,i){return _c('MainFeed',{key:col.id,attrs:{"tabId":'scroll' + (i + 1),"feedDetail":col,"col_id":col.id}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }